import { inject, Injectable } from '@angular/core';
import { DecodedAttestion } from '../entities/decoded-attestion';
import { User } from '../entities/user';
import * as CBOR from '../utils/cbor';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ServerMockService {

  private readonly userService = inject(UserService);

  registerCredential(user: User, credential: PublicKeyCredential): boolean {
    const authData = this.extractAuthData(credential);
    const credentialIdLength = this.getCredentialIdLength(authData);
    const credentialId: Uint8Array = authData.slice(55, 55 + credentialIdLength);
    const publicKeyBytes: Uint8Array = authData.slice(55 + credentialIdLength);

    const valid = true;

    if (valid) {
      user.credentials.push( { credentialId, publicKey: publicKeyBytes } );
      this.updateUser(user);
    }

    return valid;
  }

  getCredentialIdLength(authData: Uint8Array): number {
    // get the length of the credential ID
    const dataView = new DataView(new ArrayBuffer(2));
    const idLenBytes = authData.slice(53, 55);
    idLenBytes.forEach((value, index) => dataView.setUint8(index, value));
    return dataView.getUint16(0);
  }

  extractAuthData(credential: PublicKeyCredential): Uint8Array {
    const decodedAttestationObj: DecodedAttestion = CBOR.decode((credential.response as any).attestationObject);

    const { authData } = decodedAttestationObj;

    return authData;
  }

  getUsers() {
    return this.userService.getUsers();
  }

  updateUser(user: User) {
    this.removeUser(user.email);
    this.addUser(user);
  }

  addUser(user: User) {
    user.id = '' + Math.floor(Math.random() * 10000000);
    this.userService.addUser(user);
    return user;
  }

  getUser(email: string) {
    return this.userService.getUser(email);
  }

  removeUser(email: string) {
    return this.userService.removeUser(email);
  }

  getChallenge() {
    return Uint8Array.from('someChallengeIsHereComOn', c => c.charCodeAt(0));
  }
}
